module.exports = __webpack_public_path__ + "img/tima_web.e9cfaac6.png";